import useGetMyRegionPreferences from '@/api/queries/me/useGetMyRegionPreferences';

const usePreferredNumberFormat = (options?: Intl.NumberFormatOptions) => {
  const { data } = useGetMyRegionPreferences();

  return Intl.NumberFormat(data?.locale || navigator.language, options);
};

export default usePreferredNumberFormat;
